module.exports = __webpack_public_path__ + "img/tarj1-3.e22d773c.svg";